interface ChildObj {
	__text__: string,
	__ordinal__: string[]
}

export function parseXML(str: string): any {

	let parser = new DOMParser()
	let doc = parser.parseFromString(str, 'application/xml')

	let result: ChildObj = {
		'__text__': '',
		'__ordinal__': []
	}

	let root = doc.documentElement

	function traverse(e: Element, parentObj: any) {
		let childObj: ChildObj | string = undefined
		childObj = {
			'__text__': '',
			'__ordinal__': []
		}
		// from the attributes
		for (let i = 0; i < e.attributes.length; i++) {
			let key = e.attributes[i].name
			childObj[key] = e.attributes[i].value
			childObj['__ordinal__'].push(key)
		}

		// from the text node
		if (e.childNodes.length == 1 && e.childNodes[0].nodeType === 3) {
			let textContent = (e.textContent).trim()
			if (e.attributes.length > 0) {
				childObj['__text__'] = textContent
			} else {
				childObj = textContent
			}
		} else if (e.childNodes.length == 0 && e.attributes.length == 0) {
			childObj = ''
		}

		if(parentObj) {
			if (parentObj[e.nodeName]) {
				if (Array.isArray(parentObj[e.nodeName]))
				{
					parentObj[e.nodeName].push(childObj)
					parentObj['__ordinal__'].push(e.nodeName)
				} else
				{
					let lastObj = parentObj[e.nodeName]
					parentObj[e.nodeName] = []
					parentObj[e.nodeName].push(lastObj)
					parentObj[e.nodeName].push(childObj)
					parentObj['__ordinal__'].push(e.nodeName)
				}
			} else {
				if (typeof parentObj === "string") {
					parentObj = childObj

				} else
				{
					if (e.nodeName === 'Option')
					{
						parentObj[e.nodeName] = []
						parentObj[e.nodeName].push(childObj)
					}
					else
					{
						parentObj[e.nodeName] = childObj
					}
					parentObj['__ordinal__'].push(e.nodeName)
				}
			}
		}

		// Note: "children" property not supported in IE, only childElementCount
		for (let i = 0; i < e.childNodes.length; i++) {
			let children = e.childNodes
			let childNode = children.item(i)

			if (childNode instanceof Element) {
				traverse(childNode as Element, childObj)
			}
		}
	}

	traverse(root, result)

	return result
}

function createXMLNode(path: string[], attrs: string[]): Document {
	let doc = document.implementation.createDocument(null, '', null)

	let parentElement: HTMLElement | Document = doc
	let currentElement: HTMLElement
	for (let pathName of path) {
		currentElement = doc.createElement(pathName)
		parentElement.appendChild(currentElement)
		parentElement = currentElement
	}

	if (attrs.length > 0) {
		for (let i = 0; i < attrs.length; i++) {
			const name_val = attrs[i].split('=')
			const name=name_val[0]
			const value = name_val[1]
			doc.firstElementChild.setAttribute(name, value)
		}
	}

	return doc
}


export function serializeWithValue(settingsPath: string[], value: string, attrs: string[]=[]): string {

	let doc = createXMLNode(settingsPath, attrs)
	let q = settingsPath.join(' ')
	let element = doc.querySelector(q)
	element.textContent = value

	let serializer = new XMLSerializer()
	return serializer.serializeToString(doc)

}


// WEBPACK FOOTER //
// ./base/DOMXMLParser.ts